// @flow
import * as React from 'react';
import { connect } from 'react-redux';
import { setUseLocation as setUseLocationAction } from '../redux/main/actions/mainSearch';

type OwnProps = {
  children: ({ useLocation: boolean, setUseLocation: Function }) => React.Node
};

type Props = OwnProps & {
  useLocation: boolean,
  setUseLocation: Function
};

const UseLocationContainer = ({
  children,
  useLocation,
  setUseLocation
}: Props) => children({ useLocation, setUseLocation });

const mapStateToProps = ({ mainSearch: { useLocation } }) => ({ useLocation });

export default connect<Props, OwnProps, _, _, _, _>(
  mapStateToProps,
  { setUseLocation: setUseLocationAction }
)(UseLocationContainer);
